import { connect } from "react-redux";
import HotoInstallForm from "./hotoInstallForm";
import { bindActionCreators } from "redux";
import { getHotoDetails, storeHotoInstallation } from "services/redux/maintenance/hoto/action";
import {
  documentUploadUrlPublic,
  imageUploadUrlPublic
} from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  hotoDetails: state.HotoReducer.hotoDetails,
  documentUrlData: state.fileUploadReducer.imageUrlData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHotoDetails,
      imageUploadUrlPublic,
      storeHotoInstallation
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HotoInstallForm);
